import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored signed document page object.
 */
export const storedSignedDocumentPageSchema: SchemaDefinition = {
	Name: 'stored-signed-document-page',
	Properties: {
		DocumentInformation: { Type: 'object' },
		SignedDocumentPageImage: { Type: 'string' }
	}
}